import { env } from '../env'

window.API_GATEWAY_URL = env.VITE_GRAPHQL_API
window.xBufferClientId = env.VITE_X_BUFFER_CLIENT_ID

// We don't create the app shell script here, because engage consumes it directly
